import React from 'react';
import UtilityHeader from './UtilityHeader';
import MainNav from './MainNav';
import Footer from './Footer';

function Layout({ children }) {
  return (
    <div className="site-wrapper">
      <UtilityHeader />
      <MainNav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;
